module.exports = __webpack_public_path__ + "img/l.944693db.webp";